var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDeleteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#FF5353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 16.6676C7.71094 17.4043 8.35021 18.0009 9.13952 18.0009H14.8538C15.6431 18.0009 16.2824 17.4043 16.2824 16.6676V8.66797H7.71094V16.6676Z",
    fill: "#FF5353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.66662L13.7857 6H10.2143L9.49998 6.66662H7V7.99991H17V6.66662H14.5Z",
    fill: "#FF5353"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deleteIcon.829c76c9.svg";
export { ForwardRef as ReactComponent };